export class ItemData {

    id: any;
    elementId?: number;
    groupId?: number;
    name?: string;
    value: string = '';
    disabled: boolean = false;
    active?: boolean = false;
    hidden?: boolean;
    hasTopOutLine?: boolean;
    imgCls?: string;
}